import { render } from "./KPIs.vue?vue&type=template&id=04d2ddcd&scoped=true"
import script from "./KPIs.js?vue&type=script&lang=js"
export * from "./KPIs.js?vue&type=script&lang=js"

import "./KPIs.vue?vue&type=style&index=0&id=04d2ddcd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d2ddcd"]])

export default __exports__